import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';

export type TextSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl';
export type TextWeight = 'normal' | 'medium' | 'semibold' | 'bold';
export type TextColor = 'default' | 'muted' | 'subtle' | 'accent' | 'success' | 'warning' | 'error';

export interface TextProps extends HTMLAttributes<HTMLSpanElement> {
  size?: TextSize;
  weight?: TextWeight;
  color?: TextColor;
  as?: 'span' | 'p' | 'div' | 'label';
  mono?: boolean;
  children: ReactNode;
}

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  ({ 
    size = 'base', 
    weight = 'normal', 
    color = 'default', 
    as: Component = 'span',
    mono = false,
    className = '', 
    children, 
    ...props 
  }, ref) => {
    const baseClass = 'pyxl-text';
    const classes = [
      baseClass,
      `${baseClass}--size-${size}`,
      `${baseClass}--weight-${weight}`,
      `${baseClass}--color-${color}`,
      mono ? `${baseClass}--mono` : '',
      className,
    ].filter(Boolean).join(' ');

    return (
      <Component ref={ref as never} className={classes} {...props}>
        {children}
      </Component>
    );
  }
);

Text.displayName = 'Text';
